export default __webpack_public_path__ + "static/staff-photo-5-03f4ea76c772fe7e37b3f6e6ce674aa2.jpg";